import { render, staticRenderFns } from "./CustomerTransactions.vue?vue&type=template&id=6d031eb4&scoped=true"
import script from "./CustomerTransactions.vue?vue&type=script&lang=js"
export * from "./CustomerTransactions.vue?vue&type=script&lang=js"
import style0 from "./CustomerTransactions.vue?vue&type=style&index=0&id=6d031eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d031eb4",
  null
  
)

export default component.exports